import {
  merchantDelegationState
} from "./merchantDelegation.state";
import {
  merchantDelegationActions
} from "./merchantDelegation.actions";
import {
  merchantDelegationGetters
} from "./merchantDelegation.getters";
import {
  merchantDelegationMutations
} from "./merchantDelegation.mutations";

export default {
  state: merchantDelegationState,
  actions: merchantDelegationActions,
  getters: merchantDelegationGetters,
  mutations: merchantDelegationMutations
};